import { DefaultApp } from './default';
import { DowntimeWrapper } from './DowntimeWrapper';
import { Provider as JotaiProvider } from 'jotai';

export const App = () => {
  return (
    <JotaiProvider>
      <DowntimeWrapper>
        <DefaultApp />
      </DowntimeWrapper>
    </JotaiProvider>
  );
};
